import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { UnenrolledDeviceEffects } from './unenrolled-device.effects';
import { unenrolledDeviceReducer } from './unenrolled-device.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('unenrolled-device', unenrolledDeviceReducer),
    EffectsModule.forFeature([UnenrolledDeviceEffects]),
  ],
  providers: [],
})
export class UnenrolledDeviceStoreModule {}
